import axios from "axios";

// /api/gaeb — GAEB and PDF import into offers and X84/X83/X81 export (controllers/gaebController.js)
const base = `${process.env.REACT_APP_BACKEND_URL}/gaeb`;
const headers = () => ({ headers: { Authorization: "Bearer " + localStorage.getItem("token") } });

const form = (file, fields = {}) => {
  const data = new FormData();
  data.append("file", file);
  Object.entries(fields).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") data.append(key, String(value));
  });
  return data;
};

export const previewGaeb = (file, fields) =>
  axios.post(`${base}/preview`, form(file, fields), headers());
/** A PDF is read in the background: poll until status is "done" (or the request fails). */
export const pdfStatus = sha256 => axios.get(`${base}/pdf/${sha256}`, headers());
export const importGaeb = (file, fields) =>
  axios.post(`${base}/import`, form(file, fields), headers());
export const exportGaeb = (offerId, phase) =>
  axios.get(`${base}/offers/${offerId}/export`, { ...headers(), params: { phase } });
export const sourceFile = offerId =>
  axios.get(`${base}/offers/${offerId}/source`, { ...headers(), responseType: "blob" });

/** Error text from an axios error, for message.error(). */
export const errorText = (error, fallback = "Something went wrong") =>
  error?.response?.data?.errorMessage || error?.message || fallback;

export const ACCEPT =
  ".x81,.x83,.x84,.x86,.d81,.d83,.d84,.d86,.p81,.p83,.p84,.p86,.xml,.pdf,application/pdf";
